import { render, staticRenderFns } from "./LoanCommunication.vue?vue&type=template&id=7e775951&lang=pug&"
import script from "./LoanCommunication.vue?vue&type=script&lang=js&"
export * from "./LoanCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports